import { GetCustomerWelcomeResponse } from '@aaa-ncnu-ie/mypolicy-api-customers';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from './axios';

interface WelcomeResponseWithAuthToken extends GetCustomerWelcomeResponse {
  authToken: string;
}

export const getWelcomeDetails =
  async (): Promise<WelcomeResponseWithAuthToken> => {
    const { data, headers } = await axios.get<GetCustomerWelcomeResponse>(
      `${import.meta.env.VITE_CUSTOMERS_API_URL}/v1/customers/welcome`,
      {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
          'x-api-key': import.meta.env.VITE_X_API_KEY ?? '',
        },
      }
    );

    const accessToken = headers['mpr-access-token'];
    const customerKey = data?.userInfo?.custKey;

    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    axios.defaults.headers.common['Customer-Key'] = customerKey;

    return { ...data, authToken: accessToken };
  };

export const useWelcomeQuery = (enabled: boolean = true) =>
  useQuery({
    queryKey: ['welcome'],
    queryFn: () => getWelcomeDetails(),
    staleTime: 1000 * 60 * 5,
    retry: 1,
    enabled,
  });
